<template>
  <div id="app">

    <header>
      <div id="band"></div>
      <img class="skin hvr-bounce-in" src="/img/jobouille_3D.png" alt="jobouille en 3D">
      <h1 class="hvr-grow">jobouille</h1>
    </header>

    <router-view></router-view>

    <footer>
      2014 / {{ new Date().getFullYear() }} - créé par <b>jobouille</b>
    </footer>

  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import "./scss/style.scss";
</style>
